import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { useTranslation } from "react-i18next";

import './StaffModal.css';

const StaffModal = ({ isOpen, onClose, onSave, staff }) => {
    const { t } = useTranslation();
    const isEdit = !!staff;

    const [name, setName] = useState('');
    const [staffUserId, setStaffUserId] = useState('');
    const [password, setPassword] = useState('');
    const [role, setRole] = useState('shipping_staff');

    useEffect(() => {
        if (staff) {
            setName(staff.name || '');
            setStaffUserId(staff.staff_user_id || '');
            setPassword('');
            setRole(staff.role || 'shipping_staff');
        } else {
            setName('');
            setStaffUserId('');
            setPassword('');
            setRole('shipping_staff');
        }
    }, [staff, isOpen]);

    const handleSave = () => {
        const payload = {
            name,
            staff_user_id: staffUserId,
            role,
        };
        if (password) {
            payload.password = password;
        }
        onSave(payload, staff?.id);
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className="staff-modal"
            overlayClassName="staff-modal-overlay"
            contentLabel="Staff Modal"
        >
            <div className="staff-modal-title">
                {isEdit ? t('staff.edit') : t('staff.add')}
            </div>
            <div className="clearfix"></div>
            <div className="staff-modal-form">
                <div className="staff-modal-form-title">{t('staff.name')}</div>
                <div className="staff-modal-form-content">
                    <input
                        className="staff-modal-form-content-input"
                        type="text"
                        value={name}
                        onChange={e => setName(e.target.value)}
                    />
                </div>
                <div className="staff-modal-form-title">{t('staff.login_id')}</div>
                <div className="staff-modal-form-content">
                    <input
                        className="staff-modal-form-content-input"
                        type="text"
                        value={staffUserId}
                        onChange={e => setStaffUserId(e.target.value)}
                        disabled={isEdit}
                    />
                </div>
                <div className="staff-modal-form-title">{t('staff.password')}</div>
                <div className="staff-modal-form-content">
                    <input
                        className="staff-modal-form-content-input"
                        type="password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        placeholder={isEdit ? t('staff.password_placeholder') : ''}
                    />
                </div>
                <div className="staff-modal-form-title">{t('staff.role')}</div>
                <div className="staff-modal-form-content">
                    <select
                        className="staff-modal-form-content-select"
                        value={role}
                        onChange={e => setRole(e.target.value)}
                    >
                        <option value="shipping_staff">{t('staff.role_shipping')}</option>
                        <option value="customer_support">{t('staff.role_support')}</option>
                    </select>
                </div>
            </div>

            <div className="staff-modal-button">
                <button className="staff-modal-button-cancel" onClick={onClose}>{t('staff.cancel')}</button>
                <button className="staff-modal-button-save" onClick={handleSave}>{t('staff.save')}</button>
            </div>
        </Modal>
    );
};

export default StaffModal;
